// "Partial Paid", split: how much of an invoice was claimed from VLA, and how much is left to
// pay from the firm's budget. Shown wherever Partial Paid is chosen - the Disbursements page
// keeps it on the disbursement itself; the Fee Slips page keeps it in one shared vals_drafts
// record per brand, keyed by row id, the same way the "VALS to be reimbursed" ticks are kept,
// because its rows come from several back ends with no field for it.

export const PARTIAL_SPLIT_FORM_TYPE = "partial_paid_splits";

const PARTIAL_SPLIT_DRAFT_IDS = {
  vals: "00000000-0000-4000-8000-00000000c4a0",
  lacw: "00000000-0000-4000-8000-00000000c4a1",
  rga: "00000000-0000-4000-8000-00000000c4a2",
  eas: "00000000-0000-4000-8000-00000000c4a3",
  admin: "00000000-0000-4000-8000-00000000c4a4",
};
export const partialSplitDraftId = (brand) => PARTIAL_SPLIT_DRAFT_IDS[brand] || PARTIAL_SPLIT_DRAFT_IDS.lacw;

const toAmount = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const amount = Number.parseFloat(String(value).replace(/[$,\s]/g, ""));
  return Number.isFinite(amount) && amount >= 0 && amount < 10000000 ? Math.round(amount * 100) / 100 : null;
};

// The figures to show. Until "remaining from budget" is typed in, it is the invoice total less
// what was claimed from VLA.
export function partialSplit(total, vlaClaimed, fromBudget) {
  const whole = toAmount(total) ?? 0;
  const claimed = toAmount(vlaClaimed);
  const given = toAmount(fromBudget);
  const suggested = claimed === null ? null : Math.max(0, Math.round((whole - claimed) * 100) / 100);
  return {
    vlaClaimed: claimed,
    fromBudget: given ?? suggested,
    budgetTyped: given !== null,
    // A split that does not add up to the invoice is pointed out, not refused.
    mismatch: claimed !== null && given !== null && whole > 0 && Math.abs(claimed + given - whole) > 0.009,
  };
}

export const emptyPartialSplits = () => ({ splits: {} });

export function normalisePartialSplits(formData) {
  const splits = {};
  const raw = formData?.splits && typeof formData.splits === "object" ? formData.splits : {};
  for (const [id, entry] of Object.entries(raw)) {
    if (!id || !entry || typeof entry !== "object") continue;
    splits[id] = {
      vlaClaimed: toAmount(entry.vlaClaimed),
      fromBudget: toAmount(entry.fromBudget),
      updatedAt: String(entry.updatedAt || ""),
      updatedBy: String(entry.updatedBy || "").slice(0, 120),
    };
  }
  return { splits };
}

// One row's split. Clearing both figures removes it.
export function setPartialSplit(data, id, fields = {}, meta = {}) {
  const splits = { ...data.splits };
  const vlaClaimed = toAmount(fields.vlaClaimed);
  const fromBudget = toAmount(fields.fromBudget);
  if (vlaClaimed === null && fromBudget === null) {
    delete splits[id];
  } else {
    splits[id] = {
      vlaClaimed,
      fromBudget,
      updatedAt: meta.at || new Date().toISOString(),
      updatedBy: String(meta.by || "").slice(0, 120),
    };
  }
  return { ...data, splits };
}

export { toAmount as parseSplitAmount };
